import { Container, Typography } from "@mui/material";
import React from "react";

function ChooseOrderForApp() {
  return (
    <Container maxWidth="lg" sx={{ mt: 0.5 }}>
      <Typography textAlign={"center"}>Choose Order for App</Typography>
    </Container>
  );
}

export default ChooseOrderForApp;
